import { useTranslation } from "react-i18next";
import SEOHead from "../components/shared/SEOHead.jsx";
import JsonLd from "../components/shared/JsonLd.jsx";
import { buildBreadcrumbJsonLd } from "../utils/jsonld.js";
import SimplePage from "../components/shared/SimplePage.jsx";
import NewsletterForm from "../components/newsletter/NewsletterForm.jsx";

const TOPICS = ["events", "spenden", "news", "beitraege"];

export default function Newsletter({ lang }) {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead lang={lang} path="/newsletter" title={t("newsletter.metaTitle")} description={t("newsletter.metaDescription")} />
      <JsonLd
        data={buildBreadcrumbJsonLd(
          [
            { name: t("nav.home"), path: "/" },
            { name: t("nav.newsletter"), path: "/newsletter" },
          ],
          lang
        )}
      />
      <SimplePage title={t("newsletter.h1")}>
        <p style={{ fontSize: "17px", lineHeight: 1.7, color: "var(--color-ink-soft)", margin: 0 }}>
          {t("newsletter.intro")}
        </p>

        <span
          style={{
            fontSize: "11px",
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            // Not var(--color-gold): that's calibrated for the dark page
            // background (used everywhere else in this codebase only on
            // .tl-card/dark surfaces) — on this page's .tl-card-light
            // cream card it drops to a ~2.5:1 contrast ratio, well under
            // WCAG AA's 4.5:1 for normal text. This darker amber keeps the
            // same gold hue at ~5.6:1 on cream, matching how other
            // light-card pages (e.g. Verhaltenskodex.jsx's ACCENT colors)
            // already use darker, more saturated tones instead of the
            // light-surface gold.
            color: "#8a5a1f",
            marginTop: "12px",
          }}
        >
          {t("newsletter.topicsTitle")}
        </span>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(220px, 100%), 1fr))", gap: "20px" }}>
          {TOPICS.map((topic) => (
            <div
              key={topic}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                borderLeft: "3px solid var(--color-gold)",
                padding: "2px 0 2px 16px",
              }}
            >
              <span style={{ fontFamily: "var(--font-serif)", fontSize: "17px", color: "var(--color-ink)" }}>
                {t(`newsletter.topics.${topic}.title`)}
              </span>
              <span style={{ fontSize: "16px", lineHeight: 1.6, color: "var(--color-ink-soft)" }}>
                {t(`newsletter.topics.${topic}.body`)}
              </span>
            </div>
          ))}
        </div>

        <div style={{ marginTop: "12px" }}>
          <NewsletterForm lang={lang} source="Newsletter" />
        </div>
      </SimplePage>
    </>
  );
}
